"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ConnectedWidget = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _reactRouterDom = require("react-router-dom");

var _index = _interopRequireDefault(require("./sagas/index"));

var _index2 = _interopRequireDefault(require("./reducers/index"));

var _TranslationContext = require("./context/TranslationContext");

var _App = _interopRequireDefault(require("./components/App"));

var _PropsContext = require("./context/PropsContext");

var _excluded = ["i18n", "language", "__instanceId", "__pageId", "__baseUrl", "children", "tabs", "widgetCustomization"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ServiceTags = function ServiceTags(_ref) {
  var i18n = _ref.i18n,
      language = _ref.language,
      __instanceId = _ref.__instanceId,
      __pageId = _ref.__pageId,
      __baseUrl = _ref.__baseUrl,
      children = _ref.children,
      tabs = _ref.tabs,
      widgetCustomization = _ref.widgetCustomization,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var t = i18n ? function (key) {
    var tr = i18n(key);
    return tr || key;
  } : function (key) {
    return key;
  };
  if (!language) return null;
  return /*#__PURE__*/_react.default.createElement(_TranslationContext.TranslationProvider, {
    t: t
  }, /*#__PURE__*/_react.default.createElement(_PropsContext.PropsProvider, {
    widgetProps: _objectSpread({
      __instanceId: __instanceId,
      __pageId: __pageId,
      __baseUrl: __baseUrl,
      children: children,
      tabs: tabs,
      widgetCustomization: widgetCustomization
    }, restProps)
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: ["".concat(__baseUrl || '', "/:tabId"), "".concat(__baseUrl || '')]
  }, /*#__PURE__*/_react.default.createElement(_App.default, {
    instanceId: __instanceId,
    pageId: __pageId
  }))));
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    language: state.language.language
  };
};

var ConnectedWidget = (0, _reactRedux.connect)(mapStateToProps)(ServiceTags);
exports.ConnectedWidget = ConnectedWidget;
var exported = ConnectedWidget;
var _default = exported;
exports.default = _default;
ServiceTags.propTypes = {
  i18n: _propTypes.default.any,
  language: _propTypes.default.string,
  __instanceId: _propTypes.default.string,
  __pageId: _propTypes.default.string,
  __baseUrl: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]).isRequired,
  tabs: _propTypes.default.array.isRequired,
  widgetCustomization: _propTypes.default.object,
  defaultTab: _propTypes.default.string
};
exported.reducer = _index2.default;
exported.sagas = _index.default; // exported.middlewares = [logger];